import { Component, ErrorInfo, ReactNode } from 'react';
import { Box } from '@mui/material';
import Button from 'components/Button';
import Text from 'components/Text';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class IntegrationsErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Log error to console in development
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error(
        'IntegrationsErrorBoundary caught error:',
        error,
        errorInfo
      );
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    const { hasError, error } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <Box p={4} textAlign="center">
          <Text variant="h6" color="error" gutterBottom>
            Something went wrong loading the integration
          </Text>
          <Text variant="body" color="textSecondary" paragraph>
            {error?.message || 'An unexpected error occurred'}
          </Text>
          <Button variant="primary" onClick={this.handleReset}>
            Try Again
          </Button>
        </Box>
      );
    }

    return children;
  }
}
